<template>
  <div>
    <div @click="$store.commit('alex/TOGGLE_ALEX_CHAT_MODAL', true)">
      <img
        v-if="activateFeedback"
        src="../../../assets/images/demo/alex-awake-face.png"
        width="60px"
        height="auto"
        class="cursor-pointer"
      />
      <img
        v-else
        src="../../../assets/images/demo/alex-sleeping-face.png"
        width="60px"
        height="auto"
        class="cursor-pointer"
      />
    </div>
    <vs-popup :active="showAlexChat" ref="custom_modal">
      <div class="custom-modal-close" @click="showAlexChat = false">
        <vs-icon icon="close" size="20px" />
      </div>
      <div v-if="activateCompetency " style="height: 450px">
        <iframe :src="showAlexChat ? chatUrl: ''" class="w-full h-full border-0"></iframe>
      </div>
      <div v-else class="text-center">
        <img
          src="../../../assets/images/demo/alex-sleeping-face.png"
          width="250px"
          height="auto"
        />
        <h1>To activate ALEX:</h1>
        <p class="mt-4" style="text-align: center" v-if="autoLoginToken">
          Alex will be activated once your competency report is generated with at least 2 people providing you peer feedback.
        </p>
        <p class="mt-4" style="text-align: center" v-else>
          Sign-in to your profile and <br />complete your competency assessment.
        </p>

      </div>
    </vs-popup>
  </div>
</template>
<script>
export default {
  name: "AlexChat",
  data() {
    return {};
  },
  mounted() {
    this.$refs.custom_modal.$el.childNodes[1].childNodes[0].style.display =
      "none";
    this.$refs.custom_modal.$el.childNodes[1].style.maxHeight = "unset";
    this.$refs.custom_modal.$el.childNodes[1].style.height = "485px";
    this.$refs.custom_modal.$el.childNodes[1].style.width = "400px";
  },
  computed: {
    showAlexChat: {
      get() {
        return this.$store.state.alex.alexChatModal;
      },
      set(val) {
        this.$store.commit("alex/TOGGLE_ALEX_CHAT_MODAL", val);
      },
    },
    uuId() {
      return this.$store.state.alex.data.uuId;
    },
    autoLoginToken() {
      return '?tk=MhCI9rtezBuDDW88';
    },
    userProgress() {
      return 2;
    },
    activateFeedback() {
      return  2;
    },
    activateCompetency() {
      return  2;
    },
    chatId() {
      return this.$store.state.alex.chatId;
    },
    baseURL() {
      return `https://gtbrdd.typeform.com/c/${this.chatId}`;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    org() {
      return this.$store.state.organization.orgData.name;
    },
    chatUrl() {
      return `${this.baseURL}#first_name=${this.usersData.firstName || `Hi`}&org=${this.org}
      &userguid=${this.uuId}&email=${this.usersData.email}`;
    },
  },
};
</script>
<style scoped>
.con-vs-popup {
  width: 400px;
  height: 450px;
  position: fixed;
  padding: 0!important;
  bottom: 85px!important;
  right: 30px!important;
  min-height: unset;
  top: unset;
  left: unset;
}
.con-vs-popup >>> .vs-popup--background {
  display: none;
}
.custom-modal-close {
  position: absolute;
  right: 8px;
  top: -25px;
  cursor: pointer;
  height: 32px;
  width: 32px;
  border-radius: 6px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.1);
}
</style>
